export default __webpack_public_path__ + "static/media/7.0c674d79.png";